import React from 'react';
import { Card, LocalDate, Gutter, Text } from '@common/components';
import { roleLevelParser } from '@institutions/services';
import { RatesLongTermPreviewTable } from '@institutions/components';
import { RoleLevelEnum } from '@common/graphql';
import { BillingCardType } from '@institutions/graphql';
import { useCurrentMembership } from '@identity/hooks';
import { toHumanDateTimeWithTZ } from '@common/services/datetime';

const shifts = ['day', 'evening', 'night', 'variable'] as const;

export function RatesLongTermViewDrawerCard({
  rateCard,
  roleAbbreviation,
  roleLevel,
  disabled,
}: {
  rateCard: BillingCardType;
  roleAbbreviation?: string;
  roleLevel?: RoleLevelEnum;
  disabled?: boolean;
}) {
  const currentMembership = useCurrentMembership({ hideError: true });
  const timeZone = currentMembership?.worksUser?.timeZone;

  const dataSource = shifts.map((shift) => ({
    shift: shift,
    traveler: rateCard.travelerRate?.[`${shift}BillingRate`],
    local: rateCard.localRate?.[`${shift}BillingRate`],
    direct: rateCard.directSourcingRate?.[`${shift}BillingRate`],
  }));

  return (
    <Card>
      <Gutter direction="bottom" size="md">
        <Text size="xl" weight="medium" secondary={disabled}>
          {roleAbbreviation} - {roleLevelParser(roleLevel)},{' '}
          <LocalDate date={rateCard.effectiveDate ?? ''} />
        </Text>
      </Gutter>
      <RatesLongTermPreviewTable dataSource={dataSource} disabled={disabled} />
      <Gutter direction="vertical">
        <Text size="sm" secondary>
          {rateCard.createdBy.name} made these changes on{' '}
          {toHumanDateTimeWithTZ(rateCard.createdAt, timeZone)}
        </Text>
      </Gutter>
    </Card>
  );
}
